import { Button } from "@constellation-academy/epic-ui";
import { useCallback, useState } from "react";
import { useFragment, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { ihkCertificateRewardBundleForm_EditIHKCertificateRewardBundleMutation } from "@relay/ihkCertificateRewardBundleForm_EditIHKCertificateRewardBundleMutation.graphql";
import { ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment$key } from "@relay/ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment.graphql";
import {
	EDIT_IHK_CERTIFICATE_REWARD_BUNDLE_MUTATION,
	IHK_CERTIFICATE_REWARD_BUNDLE_FRAGMENT,
} from "./ihk-certificate-reward-bundle-form.graphql";
import { IHKCertificateRewardBundleFormProps } from "./ihk-certificate-reward-bundle-form.types";
import { SelectMultipleRootNodesForm } from "../../../../features/educational-offer/select-multiple-root-nodes-form";
import { makeMutableCopy } from "../../../../util/mutability";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const IHKCertificateRewardBundleForm = ({
	contentNodeId,
	ihkCertificateRewardBundleFragmentRef,
}: IHKCertificateRewardBundleFormProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [selectedRootNodes, setSelectedRootNodes] = useState<string[]>([]);

	const data = useFragment<ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment$key>(
		IHK_CERTIFICATE_REWARD_BUNDLE_FRAGMENT,
		ihkCertificateRewardBundleFragmentRef,
	);

	const [editReward, isEditingReward] =
		useMutation<ihkCertificateRewardBundleForm_EditIHKCertificateRewardBundleMutation>(
			EDIT_IHK_CERTIFICATE_REWARD_BUNDLE_MUTATION,
		);

	const handleOnRootNodesSelected = useCallback((rootNodes: string[]) => {
		setSelectedRootNodes(rootNodes);
	}, []);

	const handleOnSave = useCallback(() => {
		editReward({
			variables: {
				input: {
					contentId: contentNodeId,
					rewardId: data.id,
					newBundleIds: selectedRootNodes.length > 0 ? selectedRootNodes : data.bundleIds,
				},
			},
			updater: setDraft,
		});
	}, [editReward, contentNodeId, data.id, selectedRootNodes]);

	const bundleIds = makeMutableCopy(data.bundleIds ?? []);

	return (
		<div>
			<SelectMultipleRootNodesForm
				defaultValue={bundleIds}
				submitButtonLabel={t("educationalOffer.submitSelectedTrainings")}
				onRootNodesSelected={handleOnRootNodesSelected}
			/>
			<Button disabled={isEditingReward} label={t("actions.save")} onClick={handleOnSave} />
		</div>
	);
};
